import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { bookingUrl, onBookingClick } from "../../lib/booking";

export const SeoHeader = ({ ctaSource = "seo-nav" }) => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
                scrolled
                    ? "bg-[#070707]/90 backdrop-blur-md border-b border-white/10"
                    : "bg-transparent"
            }`}
            data-testid="seo-header"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
                <Link
                    to="/"
                    className="flex items-center gap-2 text-white"
                    data-testid="seo-logo-home"
                >
                    <span className="w-1.5 h-1.5 rounded-full bg-[#c39d63]" />
                    <span className="font-serif text-lg md:text-xl tracking-tight">
                        Brand Your{" "}
                        <span className="italic text-white/70">Expertise</span>
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
                    <Link to="/#process" className="hover:text-white">
                        Méthode
                    </Link>
                    <Link to="/#offer" className="hover:text-white">
                        Offre
                    </Link>
                    <Link to="/#portfolio" className="hover:text-white">
                        Portfolio
                    </Link>
                </nav>

                <a
                    href={bookingUrl(ctaSource)}
                    onClick={onBookingClick(ctaSource)}
                    target="_blank"
                    rel="noreferrer"
                    className="group inline-flex items-center gap-2 px-4 md:px-5 py-2 md:py-2.5 rounded-full bg-[#c39d63] text-[#0a0a0a] text-xs md:text-sm font-medium hover:bg-[#e6c891] transition-colors"
                    data-testid="seo-header-cta"
                >
                    Planifier un rendez-vous
                    <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
            </div>
        </header>
    );
};
